import axios from "axios";
import ApiConfig  from "../../configs/apiConfig";

export const axiosInstance = axios.create({
	baseURL: ApiConfig.ReceivingUrl,
});